import { RootState } from '../../shared/types/store';

export const selectModalError = (state: RootState) =>
  state.modals.modalErrorObj;

export const selectUploadSuccess = (state: RootState) =>
  state.modals.uploadSuccess;
